import {
  Button,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Space,
} from "antd";
import { useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function EndRideModal({
  open = false,
  onUpdated = () => {},
  onCancel = () => {},
  rideId,
  stations = [],
  isCancel = false,
  hideStation = false,
  rideData = {},
}) {
  const [reason, setReason] = useState("");
  const [cost, setCost] = useState(rideData.charges);
  const [selectedStation, setSelectedStation] = useState("");

  const handleEndRide = async (rideId, isCancelled = "") => {
    let data = { feedback: isCancelled, charges: cost };
    if (!hideStation) {
      data.dock_id = selectedStation;
    }
    let res = await apiRequest({
      path: apiPaths.rides + "/" + rideId + (isCancelled ? "/cancel" : "/end"),
      method: "POST",
      data: data,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onUpdated(res);
  };

  return (
    <Modal
      title={`Are you sure to ${isCancel ? "Cancel" : "End"} this Ride?`}
      centered
      //   width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <div>
        <div style={{ marginBottom: 10 }}>
          {`Note: ${
            isCancel ? "Canceling" : "Ending"
          } ride will end the ride and will ${
            isCancel ? "not detect any" : "detect"
          } ride
            cost from User wallet.`}
        </div>
        {isCancel ? (
          <>
            <div>Ride Cost to deduct </div>
            <div style={{ fontSize: 11, color: "#b7b7b7" }}>
              Note: remaining amount will be refunded
            </div>
            <InputNumber
              value={cost}
              onChange={setCost}
              placeholder="ride cost"
            />
            <div style={{ marginTop: 10 }}>Reason</div>
            <Input.TextArea
              onChange={(e) => {
                let txt = e.target.value;
                setReason(txt);
              }}
              style={{ height: 120 }}
              placeholder="reason here..."
            />
          </>
        ) : null}
        {hideStation ? null : (
          <>
            <div style={{ marginTop: 10 }}>Current Dock Station</div>
            <Select
              showSearch
              placeholder="Search and Select Station Number"
              optionFilterProp="children"
              onChange={(value) => {
                setSelectedStation(value);
              }}
              filterOption={(input, option) =>
                (option?.label ?? "").includes(input)
              }
              options={stations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
            />
          </>
        )}
      </div>
      <Space
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
      >
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={() => {
            if (reason.length || !isCancel) {
              handleEndRide(rideId, reason);
            }
          }}
        >
          {isCancel ? "Cancel Ride" : "End Ride"}
        </Button>
      </Space>
    </Modal>
  );
}

export default EndRideModal;
